import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PriceListComponent } from '../../components/price-list/price-list.component';
import { UsersComponent } from './components/user/users.component';
import { AddUserComponent } from './pages/add-user/add-user.component';
import { ChangePasswordComponent } from './pages/change-password/change-password.component';
import { CreateHolidaysDatesComponent } from './pages/create-holidays-dates/create-holidays-dates.component';
import { EditHolidaysDatesComponent } from './pages/edit-holidays-dates/edit-holidays-dates.component';
import { EditUserComponent } from './pages/edit-user/edit-user.component';
import { HolidaysDatesComponent } from './pages/holidays-dates/holidays-dates.component';
import { InviteUsersComponent } from './pages/invite-users/invite-users.component';
import { KindergartenDataComponent } from './pages/kindergarten-data/kindergarten-data.component';
import { OrganizationWorkplacesComponent } from './pages/organization-workplaces/organization-workplaces.component';

const routes: Routes = [
  { path: '', redirectTo: 'organisations-and-licenses', pathMatch: 'full' },
  { path: 'holidays-dates', component: HolidaysDatesComponent, pathMatch: 'full' },
  { path: 'holidays-dates/new', component: CreateHolidaysDatesComponent, pathMatch: 'full' },
  { path: 'holidays-dates/:uuid/edit', component: EditHolidaysDatesComponent, pathMatch: 'full' },
  { path: 'kindergarten-data', component: KindergartenDataComponent, pathMatch: 'full' },
  { path: 'price-list', component: PriceListComponent, pathMatch: 'full' },
  { path: 'user/change-password', component: ChangePasswordComponent, pathMatch: 'full' },
  { path: 'user/list/add-user', component: AddUserComponent, pathMatch: 'full' },
  { path: 'user/list/edit-user/:id', component: EditUserComponent, pathMatch: 'full' },
  { path: 'user/list', component: UsersComponent, pathMatch: 'full' },
  { path: 'user/invite', component: InviteUsersComponent },
  { path: 'organizace-a-licence', component: OrganizationWorkplacesComponent, pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SettingsRoutingModule {}
